import { css } from "@emotion/react";

export const fontDinMixin = css`
  font-family: "din-condensed", sans-serif;
  font-weight: 400;
  font-style: normal;
`;
